import { render, staticRenderFns } from "./b-button.vue?vue&type=template&id=623b73e2&"
import script from "./b-button.vue?vue&type=script&lang=js&"
export * from "./b-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports